import { Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { AuthBootstrap, RequireAuth } from './lib/auth-guard';
import { LandingPage } from './routes/landing';
import { LoginPage } from './routes/login';
import { OnboardingPage } from './routes/onboarding';
import { InviteAcceptPage } from './routes/invite-accept';
import { CellarPage } from './routes/cellar';
import { ScanPage } from './routes/scan';
import { ReceiptBulkPage } from './routes/receipt-bulk';
import { ScanBulkLabelsPage } from './routes/scan-bulk-labels';
import { NyheterPage } from './routes/nyheter';
import { UtforskPage } from './routes/utforsk';
import { WishlistPage } from './routes/wishlist';
import { FeedPage } from './routes/feed';
import { StatsPage } from './routes/stats';
import { GuidesPage } from './routes/guides';
import { GuideDetailPage } from './routes/guide-detail';
import { BarPage } from './routes/bar';
import { CocktailDetailPage } from './routes/cocktail-detail';
import { BottleDetailPage } from './routes/bottle-detail';
import { RacksPage } from './routes/racks';
import { OccasionsPage } from './routes/occasions';
import { OccasionDetailPage } from './routes/occasion-detail';
import { LabelsPage } from './routes/labels';
import { VinlistePage } from './routes/vinliste';
import { PrisautomatPage } from './routes/prisautomat';
import { BestillingPage } from './routes/bestilling';
import { VaretellingPage } from './routes/varetelling';
import { PosPage } from './routes/pos';
import { HistorikkPage } from './routes/historikk';
import { AbonnementPage } from './routes/abonnement';
import { PairPage } from './routes/pair';
import { RecommendPage } from './routes/recommend';
import { AdminPage } from './routes/admin';
import { AdminJobsPage } from './routes/admin-jobs';
import { AdminProvidersPage } from './routes/admin-providers';
import { AdminSyncPage } from './routes/admin-sync';
import { ScansPage } from './routes/scans';
import { FriendsPage } from './routes/friends';
import { FriendBarPage } from './routes/friend-bar';
import { PopularPage } from './routes/popular';
import { ProfilPage } from './routes/profil';
import { SettingsPage } from './routes/settings';
import { NotFoundPage } from './routes/not-found';

export function App() {
  return (
    <AuthBootstrap>
      <Routes>
        {/* Public */}
        <Route element={<AppShell />}>
          <Route path="/" element={<LandingPage />} />
        </Route>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/invite/:token" element={<InviteAcceptPage />} />
        <Route path="/onboarding/create-household" element={<RequireAuth><OnboardingPage /></RequireAuth>} />

        {/* Protected app */}
        <Route element={<RequireAuth><AppShell /></RequireAuth>}>
          <Route path="/cellar" element={<CellarPage />} />
          <Route path="/scan" element={<ScanPage />} />
          <Route path="/scan/receipt" element={<ReceiptBulkPage />} />
          <Route path="/scan/labels-bulk" element={<ScanBulkLabelsPage />} />
          <Route path="/nyheter" element={<NyheterPage />} />
          <Route path="/utforsk" element={<UtforskPage />} />
          <Route path="/populaer" element={<PopularPage />} />
          <Route path="/wishlist" element={<WishlistPage />} />
          <Route path="/feed" element={<FeedPage />} />
          <Route path="/stats" element={<StatsPage />} />
          <Route path="/guides" element={<GuidesPage />} />
          <Route path="/guides/:slug" element={<GuideDetailPage />} />
          <Route path="/bar" element={<BarPage />} />
          <Route path="/bar/:slug" element={<CocktailDetailPage />} />
          <Route path="/bottle/:productId" element={<BottleDetailPage />} />
          <Route path="/racks" element={<RacksPage />} />
          <Route path="/occasions" element={<OccasionsPage />} />
          <Route path="/occasions/:id" element={<OccasionDetailPage />} />
          <Route path="/pair" element={<PairPage />} />
          <Route path="/recommend" element={<RecommendPage />} />
          <Route path="/labels" element={<LabelsPage />} />
          <Route path="/vinliste" element={<VinlistePage />} />
          <Route path="/vinliste/:id" element={<VinlistePage />} />
          <Route path="/prising" element={<PrisautomatPage />} />
          <Route path="/bestilling" element={<BestillingPage />} />
          <Route path="/varetelling" element={<VaretellingPage />} />
          <Route path="/pos" element={<PosPage />} />
          <Route path="/profil" element={<ProfilPage />} />
          <Route path="/historikk" element={<HistorikkPage />} />
          <Route path="/abonnement" element={<AbonnementPage />} />
          <Route path="/scans" element={<ScansPage />} />
          <Route path="/friends" element={<FriendsPage />} />
          <Route path="/friends/:userId" element={<FriendBarPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/admin/sync" element={<AdminSyncPage />} />
          <Route path="/admin/jobs" element={<AdminJobsPage />} />
          <Route path="/admin/providers" element={<AdminProvidersPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </AuthBootstrap>
  );
}
